
export default {
    template: /*html*/`
    <div class="alert alert-primary">
        <i class="fa fa-spinner fa-spin"></i> Loading
    </div>
    `
};